import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import { useEffect, useState } from "react";
import MessageList, { Message } from "./messageList";
import ModalMessage from "./modalMessage";
import {
  get_archived_message,
  get_deleted_message,
  get_messages_for_user,
} from "../../api/messages";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { getFileAttachementByEntityId } from "../../api/fileAttachement";
import DocsInMessages from "./docsInMessage";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import "./messages.css";

//bouton proteger pour ajouter un memoire
const ProtectedBtnAddMemoire = withPermission(
  (props: any) => (
    <Link
      to="#"
      className="d-flex align-items-center justify-content-center btn btn-primary mb-3 btn-icon w-100"
      onClick={() => props.setVisible(true)}
    >
      <i className="ti ti-square-rounded-plus me-2" /> Nouveau
    </Link>
  ),
  [buildPermission(Resource.MESSAGE, Action.CREATE)],
  "masquer",
);

const MessageManagerPage = () => {
  const userData = useSelector((state: any) => state.auth.user);

  const routes = my_routes;
  const [isOpen, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [activeView, setActiveView] = useState("my_messages");
  const [myMessages, setMyMessages] = useState<Message[]>([]);
  // const [myArchivedMessages, setMyArchivedMessage] = useState<any[]>([])
  const [filteredMessage, setFilteredMessage] = useState<any[]>([]);
  const [loadingMessage, setLoadingMessages] = useState<boolean>(false);
  const [allDocs, setAllDocs] = useState<any[]>([]);

  const menuItems = [
    { key: "my_messages", label: "Tous les messages", icon: "ti-inbox", count: myMessages.length },
    { key: "messages_received", label: "Reçus", icon: "ti-mail", count: myMessages.filter((m) => m.sender_id !== userData?.id && !m.deleted && !m.archive).length },
    { key: "messages_sent", label: "Envoyés", icon: "ti-send", count: myMessages.filter((m) => m.sender_id === userData?.id && m.message_sent).length },
    { key: "draft_messages", label: "Brouillons", icon: "ti-file-pencil", count: myMessages.filter((m) => m.draft).length },
    { key: "messages_documents", label: "Documents", icon: "ti-paperclip", count: allDocs.length || undefined },
    { key: "archived_messages", label: "Archives", icon: "ti-archive", count: myMessages.filter((m) => m.archive).length },
    { key: "deleted_messages", label: "Corbeille", icon: "ti-trash", count: myMessages.filter((m) => m.deleted).length },
  ];

  const fetch_all_my_message = async () => {
    setLoadingMessages(true);
    try {
      const response = await get_messages_for_user();

      const res = await get_archived_message();

      const res2 = await get_deleted_message();
      // console.log('response: ',res2)

      let data = Array.isArray(response?.data) ? response.data : [];
      data = data.concat(res.data ?? []).concat(res2.data ?? []);

      const sorted = data.sort(
        (a: any, b: any) =>
          new Date(b?.createdAt || 0).getTime() -
          new Date(a?.createdAt || 0).getTime(),
      );
      setMyMessages(sorted);
    } catch (error: any) {
      // console.log("erreur de chargement des messages : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setLoadingMessages(false);
    }
  };

  const fetch_allDocuments = async () => {
    try {
      const responses = await Promise.all(
        myMessages.map(async (message: any) => {
          const res = await getFileAttachementByEntityId(
            message.id,
            "Message",
            buildPermissionContext(Resource.MESSAGE, Action.READ),
          );
          return Array.isArray(res.data) ? res.data : [];
        }),
      );
      // console.log("AllDocs: ",responses.flat(Infinity));
      setAllDocs(responses.flat(Infinity));
    } catch (error: any) {
      // console.log("erreur de chargement des documentss : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    fetch_all_my_message();
  }, []);

  useEffect(() => {
    switch (activeView) {
      case "messages_sent": {
        const messages = myMessages.filter(
          (msg) => msg.sender_id === userData?.id,
        );
        setFilteredMessage(messages);
        break;
      }
      case "messages_received": {
        const messages = myMessages.filter(
          (msg) => msg.sender_id !== userData?.id,
        );
        setFilteredMessage(messages);
        break;
      }
      case "draft_messages": {
        const messages = myMessages.filter((msg) => msg.draft === true);
        setFilteredMessage(messages);
        break;
      }
      case "archived_messages": {
        const messages = myMessages.filter((msg) => msg.archive === true);
        setFilteredMessage(messages);
        break;
      }
      case "deleted_messages": {
        const messages = myMessages.filter((msg) => msg.deleted === true);
        setFilteredMessage(messages);
        break;
      }
      case "messages_documents": {
        fetch_allDocuments();
        break;
      }
      default:
        setFilteredMessage(myMessages);
    }
  }, [activeView, myMessages]);

  return (
    <>
      <div className={`page-wrapper `}>
        <div className="content pb-4">
          {/* Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3 pb-3 border-bottom position-relative">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Messagerie</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Application</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Messagerie
                  </li>
                </ol>
              </nav>
            </div>
            {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <TooltipOption />
          </div> */}
            <Link
              id="toggle_btn2"
              className="notes-tog position-absolute start-0 avatar avatar-sm rounded-circle bg-primary text-white"
              to="#"
              onClick={() => setOpen(!isOpen)}
            >
              <i className="fas fa-chevron-left" />
            </Link>
          </div>
          {/* /Header */}

          <div className="row">
            <div
              className={`col-lg-3 col-md-12 sidebars-right theiaStickySidebar section-bulk-widget message-sidebar ${
                isOpen && "section-notes-dashboard"
              }
              `}
            >
              <div className="stickybar">
                <aside className="message-menu bg-white rounded-3 p-3 mb-3 mt-4 custom-sticky">
                  <div className="message-menu-title">
                    <span className="message-menu-icon"><i className="ti ti-message-circle" /></span>
                    <div><h5 className="mb-0">Messagerie</h5><small>Communication interne</small></div>
                  </div>
                  <ProtectedBtnAddMemoire setVisible={setVisible} />
                  <div className="message-menu-items">
                    {menuItems.map((item) => (
                      <button key={item.key} type="button" onClick={() => setActiveView(item.key)}
                        className={`message-menu-item ${activeView === item.key ? "active" : ""}`}>
                        <i className={`ti ${item.icon}`} /><span>{item.label}</span>
                        {item.count !== undefined && <span className="message-menu-count">{item.count}</span>}
                      </button>
                    ))}
                  </div>
                </aside>
              </div>
            </div>

            <div
              className={`col-lg-9 budget-role-notes  mt-4
            ${isOpen && "budgeted-role-notes"}`}
            >
              {activeView === "messages_documents" ? (
                <DocsInMessages files={allDocs} />
              ) : (
                <MessageList
                  messages={filteredMessage}
                  isLoading={loadingMessage}
                  refresh={() => fetch_all_my_message()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalMessage visible={visible} onCancel={() => setVisible(false)} />
    </>
  );
};
export default MessageManagerPage;
